








































































import Vue from "vue";
import { auth } from "@/store";
import TokenConfirmDialog from "@/components/layout/dialogs/TokenConfirmDialog.vue";
import Component from "vue-class-component";

@Component<LoginView>({
  watch: {
    isAuthenticated: function(newValue) {
      if (!this.dialog) {
        this.dialog = newValue;
      }
    },
  },
  components: {
    TokenConfirmDialog,
  },
})
export default class LoginView extends Vue {
  //Data
  valid: boolean = true;
  userRules: any[] = [
    (v: string) => !!v || "Introduzca su usuario",
    (v: string) =>
      (v && v.length <= 10) || "El usuario debe tener menos de 10 caracteres",
  ];
  passwordRules: any[] = [(v: string) => !!v || "Introduzca su contraseña"];
  user: string = "";
  password: string = "";
  loading: boolean = false;
  dialog: boolean = false;

  //Methods
  login() {
    this.validate();
    if (this.valid) {
      const userdata = {
        username: this.user,
        password: this.password,
      };
      this.loading = true;
      auth.dispatch("authRequest", userdata);
    }
  }
  validate() {
    (this.$refs.form as any).validate();
  }

  get isAuthenticated() {
    return auth.getters.isAuthenticated;
  }

  get authStatus() {
    return auth.getters.authStatus;
  }

  get authError() {
    return auth.getters.authError;
  }
}
